export const selectGlobalMessage = ({recipientsMessage}) => recipientsMessage.globalMessage;

export const selectMessage = ({recipientsMessage}) => {
  const {recipientSelected, recipientMessages, globalMessage} = recipientsMessage;
  return recipientMessages[recipientSelected] || globalMessage;
};

export const selectRecipientMessages = ({recipientsMessage}) => recipientsMessage.recipientMessages;
export const selectRecipientMessage =
  (guestId) =>
  ({recipientsMessage}) =>
    recipientsMessage.recipientMessages[guestId];
export const selectRecipientSelected = ({recipientsMessage}) => recipientsMessage.recipientSelected;

export const selectRecipientFilter = ({recipientsMessage}) => recipientsMessage.recipientFilter;

export const selectPersistAllMessages = ({recipientsMessage}) =>
  recipientsMessage.persistAllMessages;
